import { motion } from "framer-motion";
import {
  IconBriefcase,
  IconCertificate,
  IconUsers,
} from "@tabler/icons-react";
import { fadeUp, stagger, cardAnimation } from "./animations";

export default function LearningBenefits() {
  return (
    <section className="bg-[#111111] py-20 text-white sm:py-24 lg:py-28">
      <div
        className="
          mx-auto
          max-w-7xl
          px-5
          sm:px-8
          lg:px-10
        "
      >
        <motion.div
          variants={fadeUp}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          className="max-w-3xl"
        >
          <p
            className="
              text-xs
              font-bold
              uppercase
              tracking-[0.2em]
              text-[#55aef3]
            "
          >
            Beyond The Course
          </p>

          <h2
            className="
              merriweather
              mt-5
              text-3xl
              font-black
              tracking-[-0.04em]
              sm:text-4xl
              lg:text-[52px]
            "
          >
            Learn skills
            Build experience.
          </h2>
        </motion.div>

        <motion.div
          variants={stagger}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          className="
            mt-12
            grid
            gap-px
            overflow-hidden
            rounded-[20px]
            bg-white/10
            md:grid-cols-3
          "
        >
          <Benefit
            icon={<IconBriefcase />}
            title="Practical Projects"
            text="Apply what you learn through hands-on exercises and project-based work."
          />

          <Benefit
            icon={<IconCertificate />}
            title="Certification"
            text="Complete your training with course certification from WE3X Institute."
          />

          <Benefit
            icon={<IconUsers />}
            title="Career Guidance"
            text="Build technical confidence and prepare for real-world career opportunities."
          />
        </motion.div>
      </div>
    </section>
  );
}

function Benefit({ icon, title, text }) {
  return (
    <motion.div
      variants={cardAnimation}
      className="
        bg-[#111111]
        p-7
        sm:p-8
      "
    >
      <div
        className="
          flex
          h-11
          w-11
          items-center
          justify-center
          rounded-xl
          bg-[#55aef3]
          text-white
        "
      >
        {icon}
      </div>

      <h3 className="merriweather mt-7 text-xl font-bold">{title}</h3>

      <p className="mt-3 text-sm leading-7 text-white/50">{text}</p>
    </motion.div>
  );
}
